import { Map, View } from 'ol';
// import TileLayer from 'ol/layer/Tile';
// import OSM from 'ol/source/OSM';
import { defaults as defaultControls } from 'ol/control';
import ZoomSlider from 'ol/control/ZoomSlider';
import { extend, intersects } from 'ol/extent';

import { newSwitch, WizardSwitch } from './controls';
import { rightSize } from './draw';
import { getWMS } from './layers';

export const map = new Map({
  target: 'map',
  // layers: [ ], // new TileLayer({ source: new OSM() }) ],
  view: new View({ center: [0, 0], zoom: 0 }),
  controls: defaultControls().extend([
    new ZoomSlider, new WizardSwitch,
    newSwitch('flybilder', 'Nyeste', 'flyFS'),
    newSwitch('ar5', 'AR5', 'gkFS'),
    newSwitch('grunnkart', 'Grunnkart', 'gkFS'),
    newSwitch('skogbonitet', 'Skogbonitet', 'gkFS'),
    newSwitch('kp', 'Nåværende', 'kFS'),
    newSwitch('kpf', 'Forslag', 'kFS'),
    newSwitch('kpp', 'Planområde', 'kFS'),
    newSwitch('kdp', 'Nåværende', 'kdFS'),
    newSwitch('kdpf', 'Forslag', 'kdFS'),
    newSwitch('kdpp', 'Planområde', 'kdFS'),
    newSwitch('rp', 'Nåværende', 'rFS'),
    newSwitch('rpf', 'Forslag', 'rFS'),
    newSwitch('rpp', 'Planområde', 'rFS'),
    newSwitch('eiendom', 'Grenser', 'egFS'),
    newSwitch('gnr', 'Gårds- og bruksnummer', 'egFS'),
    // newSwitch('tønsberg', 'Tønsberg og Drammen', 'utFS'),
  ])
});

export const getLayerByFeature = (f) => {
  const layers = map.getLayers();
  const nl = layers.getLength();
  for (let i = 0; i < nl; i++) {
    const l = layers.item(i);
    const drawn = (l.get('type') === 'drawings');
    const uploaded = (l.get('type') === 'file');
    if ((drawn || uploaded) && l.getSource().hasFeature(f)) return l;
  }
  return null;
};

export const getLegendUrl = (wmsId, layerName) => {
  const nwu = getWMS(wmsId).getSource().getLegendUrl(undefined, layerName);
  const v1 = nwu.replace('1.3.0', '1.1.1');
  const wu = v1.split('LAYER=')[0]
  // return v1.split('%2C')[0];
  return wu + 'LAYER=' + layerName;
};

const zoomToExtent = (e) => {
  const view = map.getView();
  const z = view.getZoom();
  const fit = () => view.fit(
    e, { duration: 2000, padding: [50, 50, 50, 50] }
  );
  const visibleDestination = intersects(view.calculateExtent(), e);
  if (z < 8 || visibleDestination) fit();
  else view.animate({ zoom: 7 }, fit);
};

export const zoomToFeature = (feature) => {
  // map.getView().fit(feature.getGeometry());
  zoomToExtent(feature.getGeometry().getExtent());
};

export const zoomToLayer = (layer) => {
  zoomToExtent(layer.getSource().getExtent());
};

export const zoomToAll = (layers) => {
  let all;
  layers.forEach(layer => {
    const single = layer.getSource().getExtent();
    if (!all) all = single; else extend(all, single);
  });
  if (all) zoomToExtent(all);
};

export const zoomToPlanId = (layer, planid) => {
  let all;
  layer.getSource().getFeatures().forEach(feature => {
    if (feature.get('planid') === planid){
      const single = feature.getGeometry().getExtent();
      if (!all) all = single; else extend(all, single);
    }
  });
  if (all) zoomToExtent(all);
};

export const togglePlanId = (layer, planid, active) => {
  layer.getSource().getFeatures().forEach(feature => {
    const match = (feature.get('suitable') && feature.get('planid') === planid);
    if (match) feature.set('checked', active);
  });
};

export const highlightPlanId = (layer, planid, highlight) => {
  layer.getSource().getFeatures().forEach(feature => {
    if (feature.get('planid') === planid) feature.set('highlight', highlight);
  });
};

export const setPlanIdOpacity = (layer, planid, opacity) => {
  layer.getSource().forEachFeature(feature => {
    if (feature.get('planid') === planid) feature.set('opacity', opacity);
  });
};

export const setPlanIdTitle = (layer, planid, title) => {
  layer.getSource().forEachFeature(feature => {
    if (feature.get('planid') === planid) feature.set('title', title);
  });
};

export const removePlanId = (layer, planid) => {
  const s = layer.getSource();
  s.forEachFeature(feature => {
    if (feature.get('planid') === planid) s.removeFeature(feature);
  });
};

export const getListSelectedFeatures = () => {
  const filteredFeatures = [];
  // Send features belonging to drawn and uploaded layers of right size:
  map.getLayers().getArray().filter(
    l => ['drawings', 'file'].indexOf(l.get('type')) > -1
  ).forEach(s => s.getSource().getFeatures().filter(f =>
    f.get('checked') && (f.get('arealformål') || f.get('drawn')) && rightSize(f)
  ).forEach(f => filteredFeatures.push(f.clone())));
  return filteredFeatures;
};
